const PROFANITY_PATTERNS = [
  /\bf[\W_]*u[\W_]*c[\W_]*k(?:ing|er|ed|s)?\b/i,
  /\bsh[\W_]*i[\W_]*t(?:ty|ting|ted|s)?\b/i,
  /\bb[\W_]*i[\W_]*t[\W_]*c[\W_]*h(?:es|y)?\b/i,
  /\ba[\W_]*s[\W_]*s[\W_]*h[\W_]*o[\W_]*l[\W_]*e(?:s)?\b/i,
  /\bb[\W_]*a[\W_]*s[\W_]*t[\W_]*a[\W_]*r[\W_]*d(?:s)?\b/i,
  /\bc[\W_]*u[\W_]*n[\W_]*t(?:s)?\b/i,
];

const extractText = (node) => {
  if (!node) return "";
  if (typeof node === "string") return node;
  if (Array.isArray(node)) return node.map((item) => extractText(item)).join(" ");
  if (typeof node.text === "string") return node.text;
  if (Array.isArray(node.children)) return extractText(node.children);
  return "";
};

export const containsProfanity = (text = "") => {
  if (!text) return false;
  return PROFANITY_PATTERNS.some((pattern) => pattern.test(text));
};

export const getTranscriptText = (transcripts = []) => {
  if (!Array.isArray(transcripts) || transcripts.length === 0) return "";
  return extractText(transcripts).replace(/\s+/g, " ").trim();
};

export const findProfanityMatches = (transcripts = []) => {
  if (!Array.isArray(transcripts) || transcripts.length === 0) return [];

  const matches = [];
  for (const snippet of transcripts) {
    if (snippet?.type !== "snippet") continue;
    const text = extractText(snippet).replace(/\s+/g, " ").trim();
    if (!text || !containsProfanity(text)) continue;
    matches.push({
      text,
      timestamp: snippet.start_timestamp || snippet.start || "",
      speaker: snippet.speaker || "",
    });
  }
  return matches;
};
